import { createApiClient } from './axios-instance';
import { BaseResponse } from './auth.service';
import {
  InvitationGenerateRequest,
  InvitationResponse,
  WorkspaceJoinRequest,
  WorkspaceJoinResponse,
  WorkspaceInfo,
} from '../types/invitation.types';

class InvitationService {
  /**
   * Generate workspace invitation
   */
  async generateInvitation(
    workspaceId: string,
    requestData: InvitationGenerateRequest,
    idToken: string
  ): Promise<InvitationResponse> {
    try {
      const client = createApiClient(idToken);
      const response = await client.post<BaseResponse<InvitationResponse>>(
        `/workspaces/${workspaceId}/generate-invite`,
        requestData
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to generate invitation');
      }

      return response.data.data!;
    } catch (error) {
      console.error('Failed to generate invitation:', error);
      throw error;
    }
  }

  /**
   * Get workspace info by code (public endpoint)
   */
  async getWorkspaceByCode(workspaceCode: string): Promise<WorkspaceInfo> {
    try {
      const client = createApiClient();
      const response = await client.get<BaseResponse<WorkspaceInfo>>(
        `/workspaces/by-code/${workspaceCode}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to get workspace info');
      }

      return response.data.data!;
    } catch (error) {
      console.error('Failed to get workspace info:', error);
      throw error;
    }
  }

  /**
   * Join workspace with invitation token
   */
  async joinWorkspace(
    workspaceCode: string,
    joinData: WorkspaceJoinRequest,
    idToken: string
  ): Promise<WorkspaceJoinResponse> {
    try {
      const client = createApiClient(idToken);
      const response = await client.post<BaseResponse<WorkspaceJoinResponse>>(
        `/workspaces/${workspaceCode}/join`,
        joinData
      );

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to join workspace');
      }

      return response.data.data!;
    } catch (error) {
      console.error('Failed to join workspace:', error);
      throw error;
    }
  }
}

export const invitationService = new InvitationService();
